import { jsx as A, jsxs as Y } from "react/jsx-runtime";
import zt, { createContext as $t, useContext as Ft, useRef as L, useSyncExternalStore as It, useCallback as Vt, useMemo as pt, useEffect as F, useLayoutEffect as qt, memo as Kt, forwardRef as ct, createElement as Gt, Children as Bt, isValidElement as Ut, cloneElement as Jt } from "react";
import { Paragraph as dt } from "./atoms/Paragraph/Paragraph.es.js";
import { Tooltip as yt } from "./atoms/Tooltip/Tooltip.es.js";
import { chakra as G } from "@chakra-ui/react";
import { InfoIcon as gt } from "./icons/index.es.js";
import "react-dom";
function Zt(t, e) {
  return `${t} returned \`undefined\`. Seems you forgot to wrap component within ${e}`;
}
function Qt(t = {}) {
  const {
    name: e,
    strict: i = !0,
    hookName: n = "useContext",
    providerName: c = "Provider",
    errorMessage: h
  } = t, y = $t(void 0);
  y.displayName = e;
  function f() {
    var s;
    const v = Ft(y);
    if (!v && i) {
      const r = new Error(h ?? Zt(n, c));
      throw r.name = "ContextError", (s = Error.captureStackTrace) == null || s.call(Error, r, f), r;
    }
    return v;
  }
  return [y.Provider, f, y];
}
const Xt = Symbol(), at = Symbol(), W = "a", q = "w";
let Yt = (t, e) => new Proxy(t, e);
const nt = Object.getPrototypeOf, it = /* @__PURE__ */ new WeakMap(), Pt = (t) => t && (it.has(t) ? it.get(t) : nt(t) === Object.prototype || nt(t) === Array.prototype), mt = (t) => typeof t == "object" && t !== null, Ht = (t) => {
  if (Array.isArray(t))
    return Array.from(t);
  const e = Object.getOwnPropertyDescriptors(t);
  return Object.values(e).forEach((i) => {
    i.configurable = !0;
  }), Object.create(nt(t), e);
}, Mt = (t) => t[at] || t, Ct = (t, e, i, n) => {
  if (!Pt(t))
    return t;
  let c = n && n.get(t);
  if (!c) {
    const v = Mt(t);
    c = ((s) => Object.values(Object.getOwnPropertyDescriptors(s)).some((r) => !r.configurable && !r.writable))(v) ? [v, Ht(v)] : [v], n == null || n.set(t, c);
  }
  const [h, y] = c;
  let f = i && i.get(h);
  return f && f[1].f === !!y || (f = ((v, s) => {
    const r = { f: s };
    let o = !1;
    const a = (l, p) => {
      if (!o) {
        let E = r[W].get(v);
        if (E || (E = {}, r[W].set(v, E)), l === q)
          E[q] = !0;
        else {
          let w = E[l];
          w || (w = /* @__PURE__ */ new Set(), E[l] = w), w.add(p);
        }
      }
    }, u = { get: (l, p) => p === at ? v : (a("k", p), Ct(Reflect.get(l, p), r[W], r.c, r.t)), has: (l, p) => p === Xt ? (o = !0, r[W].delete(v), !0) : (a("h", p), Reflect.has(l, p)), getOwnPropertyDescriptor: (l, p) => (a("o", p), Reflect.getOwnPropertyDescriptor(l, p)), ownKeys: (l) => (a(q), Reflect.ownKeys(l)) };
    return s && (u.set = u.deleteProperty = () => !1), [u, r];
  })(h, !!y), f[1].p = Yt(y || h, f[0]), i && i.set(h, f)), f[1][W] = e, f[1].c = i, f[1].t = n, f[1].p;
}, Dt = (t, e, i, n, c = Object.is) => {
  if (c(t, e))
    return !1;
  if (!mt(t) || !mt(e))
    return !0;
  const h = i.get(Mt(t));
  if (!h)
    return !0;
  if (n) {
    const f = n.get(t);
    if (f && f.n === e)
      return f.g;
    n.set(t, { n: e, g: !1 });
  }
  let y = null;
  try {
    for (const f of h.h || [])
      if (y = Reflect.has(t, f) !== Reflect.has(e, f), y)
        return y;
    if (h[q] === !0) {
      if (y = ((f, v) => {
        const s = Reflect.ownKeys(f), r = Reflect.ownKeys(v);
        return s.length !== r.length || s.some((o, a) => o !== r[a]);
      })(t, e), y)
        return y;
    } else
      for (const f of h.o || [])
        if (y = !!Reflect.getOwnPropertyDescriptor(t, f) != !!Reflect.getOwnPropertyDescriptor(e, f), y)
          return y;
    for (const f of h.k || [])
      if (y = Dt(t[f], e[f], i, n, c), y)
        return y;
    return y === null && (y = !0), y;
  } finally {
    n && n.set(t, { n: e, g: y });
  }
}, te = (t) => Pt(t) && t[at] || null, vt = (t, e = !0) => {
  it.set(t, e);
};
var B = process.env.NODE_ENV !== "production", H = (t) => typeof t == "object" && t !== null, D = /* @__PURE__ */ new WeakMap(), z = /* @__PURE__ */ new WeakSet(), ee = (t = Object.is, e = (s, r) => new Proxy(s, r), i = (s) => H(s) && !z.has(s) && (Array.isArray(s) || !(Symbol.iterator in s)) && !(s instanceof WeakMap) && !(s instanceof WeakSet) && !(s instanceof Error) && !(s instanceof Number) && !(s instanceof Date) && !(s instanceof String) && !(s instanceof RegExp) && !(s instanceof ArrayBuffer), n = (s) => {
  switch (s.status) {
    case "fulfilled":
      return s.value;
    case "rejected":
      throw s.reason;
    default:
      throw s;
  }
}, c = /* @__PURE__ */ new WeakMap(), h = (s, r, o = n) => {
  const a = c.get(s);
  if ((a == null ? void 0 : a[0]) === r)
    return a[1];
  const u = Array.isArray(s) ? [] : Object.create(Object.getPrototypeOf(s));
  return vt(u, !0), c.set(s, [r, u]), Reflect.ownKeys(s).forEach((l) => {
    const p = Reflect.get(s, l);
    z.has(p) ? (vt(p, !1), u[l] = p) : p instanceof Promise ? Object.defineProperty(u, l, {
      get() {
        return o(p);
      }
    }) : D.has(p) ? u[l] = C(p, o) : u[l] = p;
  }), Object.freeze(u);
}, y = /* @__PURE__ */ new WeakMap(), f = [1, 1], v = (s) => {
  if (!H(s))
    throw new Error("object required");
  const r = y.get(s);
  if (r)
    return r;
  let o = f[0];
  const a = /* @__PURE__ */ new Set(), u = (S, m = ++f[0]) => {
    o !== m && (o = m, a.forEach((g) => g(S, m)));
  };
  let l = f[1];
  const p = (S = ++f[1]) => (l !== S && !a.size && (l = S, w.forEach(([m]) => {
    const g = m[1](S);
    g > o && (o = g);
  })), o), E = (S) => (m, g) => {
    const b = [...m];
    b[1] = [S, ...b[1]], u(b, g);
  }, w = /* @__PURE__ */ new Map(), N = (S, m) => {
    if (B && w.has(S))
      throw new Error("prop listener already exists");
    if (a.size) {
      const g = m[3](E(S));
      w.set(S, [m, g]);
    } else
      w.set(S, [m]);
  }, Q = (S) => {
    var g;
    const m = w.get(S);
    m && (w.delete(S), (g = m[1]) == null || g.call(m));
  }, ut = (S) => (a.add(S), a.size === 1 && w.forEach(([g, b], _) => {
    if (B && b)
      throw new Error("remove already exists");
    const T = g[3](E(_));
    w.set(_, [g, T]);
  }), () => {
    a.delete(S), a.size === 0 && w.forEach(([g, b], _) => {
      b && (b(), w.set(_, [g]));
    });
  }), X = Array.isArray(s) ? [] : Object.create(Object.getPrototypeOf(s)), I = e(X, {
    deleteProperty(S, m) {
      const g = Reflect.get(S, m);
      Q(m);
      const b = Reflect.deleteProperty(S, m);
      return b && u(["delete", [m], g]), b;
    },
    set(S, m, g, b) {
      var lt;
      const _ = Reflect.has(S, m), T = Reflect.get(S, m, b);
      if (_ && (t(T, g) || y.has(g) && t(T, y.get(g))))
        return !0;
      Q(m), H(g) && (g = te(g) || g);
      let V = g;
      if (!((lt = Object.getOwnPropertyDescriptor(S, m)) != null && lt.set))
        if (g instanceof Promise)
          g.then((P) => {
            g.status = "fulfilled", g.value = P, u(["resolve", [m], P]);
          }).catch((P) => {
            g.status = "rejected", g.reason = P, u(["reject", [m], P]);
          });
        else {
          !D.has(g) && i(g) && (V = ht(g));
          const P = !z.has(V) && D.get(V);
          P && N(m, P);
        }
      return Reflect.set(S, m, V, b), u(["set", [m], g, T]), !0;
    }
  });
  y.set(s, I);
  const kt = [X, p, h, ut];
  return D.set(I, kt), Reflect.ownKeys(s).forEach((S) => {
    const m = Object.getOwnPropertyDescriptor(s, S);
    m.get || m.set ? Object.defineProperty(X, S, m) : I[S] = s[S];
  }), I;
}) => [
  // public functions
  v,
  // shared state
  D,
  z,
  // internal things
  t,
  e,
  i,
  n,
  c,
  h,
  y,
  f
], [se] = ee();
function ht(t = {}) {
  return se(t);
}
function rt(t, e, i) {
  const n = D.get(t);
  B && !n && console.warn("Please use proxy object");
  let c;
  const h = [], y = n[3];
  let f = !1;
  const s = y((r) => {
    if (h.push(r), i) {
      e(h.splice(0));
      return;
    }
    c || (c = Promise.resolve().then(() => {
      c = void 0, f && e(h.splice(0));
    }));
  });
  return f = !0, () => {
    f = !1, s();
  };
}
function C(t, e) {
  const i = D.get(t);
  B && !i && console.warn("Please use proxy object");
  const [n, c, h] = i;
  return h(n, c(), e);
}
function St(t) {
  return z.add(t), t;
}
function ne(t, e) {
  Object.keys(e).forEach((c) => {
    if (Object.getOwnPropertyDescriptor(t, c))
      throw new Error("object property already defined");
    const h = e[c], { get: y, set: f } = typeof h == "function" ? { get: h } : h, v = {};
    v.get = () => y(C(n)), f && (v.set = (s) => f(n, s)), Object.defineProperty(t, c, v);
  });
  const n = ht(t);
  return n;
}
function Et(t, e, i) {
  typeof i.value == "object" && (i.value = R(i.value)), !i.enumerable || i.get || i.set || !i.configurable || !i.writable || e === "__proto__" ? Object.defineProperty(t, e, i) : t[e] = i.value;
}
function R(t) {
  if (typeof t != "object")
    return t;
  var e = 0, i, n, c, h = Object.prototype.toString.call(t);
  if (h === "[object Object]" ? c = Object.create(t.__proto__ || null) : h === "[object Array]" ? c = Array(t.length) : h === "[object Set]" ? (c = /* @__PURE__ */ new Set(), t.forEach(function(y) {
    c.add(R(y));
  })) : h === "[object Map]" ? (c = /* @__PURE__ */ new Map(), t.forEach(function(y, f) {
    c.set(R(f), R(y));
  })) : h === "[object Date]" ? c = /* @__PURE__ */ new Date(+t) : h === "[object RegExp]" ? c = new RegExp(t.source, t.flags) : h === "[object DataView]" ? c = new t.constructor(R(t.buffer)) : h === "[object ArrayBuffer]" ? c = t.slice(0) : h.slice(-6) === "Array]" && (c = new t.constructor(t)), c) {
    for (n = Object.getOwnPropertySymbols(t); e < n.length; e++)
      Et(c, n[e], Object.getOwnPropertyDescriptor(t, n[e]));
    for (e = 0, n = Object.getOwnPropertyNames(t); e < n.length; e++)
      Object.hasOwnProperty.call(c, i = n[e]) && c[i] === t[i] || Et(c, i, Object.getOwnPropertyDescriptor(t, i));
  }
  return c || t;
}
var ie = Object.defineProperty, re = (t, e, i) => e in t ? ie(t, e, { enumerable: !0, configurable: !0, writable: !0, value: i }) : t[e] = i, d = (t, e, i) => (re(t, typeof e != "symbol" ? e + "" : e, i), i);
function oe(t) {
  for (; t.length > 0; )
    t.pop();
  return t;
}
var wt = (t, ...e) => (typeof t == "function" ? t(...e) : t) ?? void 0, j = (t) => t, ce = () => {
}, ae = (...t) => (...e) => {
  t.forEach(function(i) {
    i == null || i(...e);
  });
}, bt = /* @__PURE__ */ (() => {
  let t = 0;
  return () => (t++, t.toString(36));
})(), he = () => process.env.NODE_ENV !== "production", U = (t) => Array.isArray(t), $ = (t) => !(t == null || typeof t != "object" || U(t)), fe = (t) => typeof t == "number" && !Number.isNaN(t), O = (t) => typeof t == "string", J = (t) => typeof t == "function", ue = (t, e) => Object.prototype.hasOwnProperty.call(t, e);
function Z(t) {
  if (!le(t) || t === void 0)
    return t;
  const e = Reflect.ownKeys(t).filter((n) => typeof n == "string"), i = {};
  for (const n of e) {
    const c = t[n];
    c !== void 0 && (i[n] = Z(c));
  }
  return i;
}
var le = (t) => t && typeof t == "object" && t.constructor === Object;
function tt(...t) {
  const e = t.length === 1 ? t[0] : t[1];
  (t.length === 2 ? t[0] : !0) && process.env.NODE_ENV !== "production" && console.warn(e);
}
function K(...t) {
  const e = t.length === 1 ? t[0] : t[1];
  if ((t.length === 2 ? t[0] : !0) && process.env.NODE_ENV !== "production")
    throw new Error(e);
}
function Nt(t, ...e) {
  for (const i of e) {
    const n = Z(i);
    for (const c in n)
      $(i[c]) ? (t[c] || (t[c] = {}), Nt(t[c], i[c])) : t[c] = i[c];
  }
  return t;
}
function xt(t) {
  return R(t);
}
function x(t) {
  return O(t) ? { type: t } : t;
}
function M(t) {
  return t ? U(t) ? t.slice() : [t] : [];
}
function _t(t) {
  return $(t) && t.predicate != null;
}
var pe = () => !0;
function ft(t, e, i, n) {
  return (c) => {
    var h;
    return O(c) ? !!((h = t[c]) != null && h.call(t, e, i, n)) : J(c) ? c(e, i, n) : c.predicate(t)(e, i, n);
  };
}
function de(...t) {
  return {
    predicate: (e) => (i, n, c) => t.map(ft(e, i, n, c)).some(Boolean)
  };
}
function ye(...t) {
  return {
    predicate: (e) => (i, n, c) => t.map(ft(e, i, n, c)).every(Boolean)
  };
}
function ge(t) {
  return {
    predicate: (e) => (i, n, c) => !ft(e, i, n, c)(t)
  };
}
function me(...t) {
  return (e, i, n) => n.state.matches(...t);
}
var Be = { or: de, and: ye, not: ge, stateIn: me };
function Rt(t, e) {
  return t = t ?? pe, (i, n, c) => {
    if (O(t)) {
      const h = e[t];
      return J(h) ? h(i, n, c) : h;
    }
    return _t(t) ? t.predicate(e)(i, n, c) : t == null ? void 0 : t(i, n, c);
  };
}
function et(t, e) {
  return (i, n, c) => _t(t) ? t.predicate(e)(i, n, c) : t;
}
function ve(t) {
  var h, y;
  const e = t.computed ?? j({}), i = t.context ?? j({}), n = t.initial ? (y = (h = t.states) == null ? void 0 : h[t.initial]) == null ? void 0 : y.tags : [], c = ht({
    value: t.initial ?? "",
    previousValue: "",
    event: j({}),
    previousEvent: j({}),
    context: ne(i, e),
    done: !1,
    tags: n ?? [],
    hasTag(f) {
      return this.tags.includes(f);
    },
    matches(...f) {
      return f.includes(this.value);
    },
    can(f) {
      return j(this).nextEvents.includes(f);
    },
    get nextEvents() {
      var s, r;
      const f = ((r = (s = t.states) == null ? void 0 : s[this.value]) == null ? void 0 : r.on) ?? {}, v = (t == null ? void 0 : t.on) ?? {};
      return Object.keys({ ...f, ...v });
    },
    get changed() {
      return this.event.value === "machine.init" || !this.previousValue ? !1 : this.value !== this.previousValue;
    }
  });
  return j(c);
}
function k(t, e) {
  return (i, n) => {
    if (fe(t))
      return t;
    if (J(t))
      return t(i, n);
    if (O(t)) {
      const c = Number.parseFloat(t);
      if (!Number.isNaN(c))
        return c;
      if (e) {
        const h = e == null ? void 0 : e[t];
        return K(
          h == null,
          `[@zag-js/core > determine-delay] Cannot determine delay for \`${t}\`. It doesn't exist in \`options.delays\``
        ), J(h) ? h(i, n) : h;
      }
    }
  };
}
function Se(t) {
  return O(t) ? { target: t } : t;
}
function Ee(t, e) {
  return (i, n, c) => M(t).map(Se).find((h) => Rt(h.guard, e)(i, n, c) ?? h.target ?? h.actions);
}
var we = class {
  // Let's get started!
  constructor(t, e) {
    var n, c, h, y, f, v;
    d(
      this,
      "status",
      "Not Started"
      /* NotStarted */
    ), d(this, "state"), d(this, "initialState"), d(this, "initialContext"), d(this, "id"), d(
      this,
      "type",
      "machine"
      /* Machine */
    ), d(this, "activityEvents", /* @__PURE__ */ new Map()), d(this, "delayedEvents", /* @__PURE__ */ new Map()), d(this, "stateListeners", /* @__PURE__ */ new Set()), d(this, "doneListeners", /* @__PURE__ */ new Set()), d(this, "contextWatchers", /* @__PURE__ */ new Set()), d(this, "removeStateListener", ce), d(this, "parent"), d(this, "children", /* @__PURE__ */ new Map()), d(this, "guardMap"), d(this, "actionMap"), d(this, "delayMap"), d(this, "activityMap"), d(this, "sync"), d(this, "options"), d(this, "config"), d(this, "start", (s) => {
      if (this.state.value = "", this.state.tags = [], this.status === "Running")
        return this;
      this.status = "Running", this.removeStateListener = rt(
        this.state,
        () => {
          this.stateListeners.forEach((p) => {
            p(this.stateSnapshot);
          });
        },
        this.sync
      ), this.setupContextWatchers(), this.executeActivities(
        x(
          "machine.start"
          /* Start */
        ),
        M(this.config.activities),
        "machine.start"
        /* Start */
      ), this.executeActions(this.config.entry, x(
        "machine.start"
        /* Start */
      ));
      const r = x(
        "machine.init"
        /* Init */
      ), o = $(s) ? s.value : s, a = $(s) ? s.context : void 0;
      a && this.setContext(a);
      const u = {
        target: o ?? this.config.initial
      }, l = this.getNextStateInfo(u, r);
      return this.initialState = l, this.performStateChangeEffects(this.state.value, l, r), this;
    }), d(this, "setupContextWatchers", () => {
      const { watch: s } = this.config;
      if (!s)
        return;
      let r = C(this.state.context);
      const o = rt(this.state.context, () => {
        var u;
        const a = C(this.state.context);
        for (const [l, p] of Object.entries(s))
          (((u = this.options.compareFns) == null ? void 0 : u[l]) ?? Object.is)(r[l], a[l]) || this.executeActions(p, this.state.event);
        r = a;
      });
      this.contextWatchers.add(o);
    }), d(this, "stop", () => {
      if (this.status !== "Stopped")
        return this.performExitEffects(this.state.value, x(
          "machine.stop"
          /* Stop */
        )), this.executeActions(this.config.exit, x(
          "machine.stop"
          /* Stop */
        )), this.setState(""), this.setEvent(
          "machine.stop"
          /* Stop */
        ), this.stopStateListeners(), this.stopChildren(), this.stopActivities(), this.stopDelayedEvents(), this.stopContextWatchers(), this.status = "Stopped", this;
    }), d(this, "stopStateListeners", () => {
      this.removeStateListener(), this.stateListeners.clear();
    }), d(this, "stopContextWatchers", () => {
      this.contextWatchers.forEach((s) => s()), this.contextWatchers.clear();
    }), d(this, "stopDelayedEvents", () => {
      this.delayedEvents.forEach((s) => {
        s.forEach((r) => r());
      }), this.delayedEvents.clear();
    }), d(this, "stopActivities", (s) => {
      var r, o;
      s ? ((r = this.activityEvents.get(s)) == null || r.forEach((a) => a()), (o = this.activityEvents.get(s)) == null || o.clear(), this.activityEvents.delete(s)) : (this.activityEvents.forEach((a) => {
        a.forEach((u) => u()), a.clear();
      }), this.activityEvents.clear());
    }), d(this, "sendChild", (s, r) => {
      const o = x(s), a = wt(r, this.contextSnapshot), u = this.children.get(a);
      u || K(`[@zag-js/core] Cannot send '${o.type}' event to unknown child`), u.send(o);
    }), d(this, "stopChild", (s) => {
      this.children.has(s) || K(`[@zag-js/core > stop-child] Cannot stop unknown child ${s}`), this.children.get(s).stop(), this.children.delete(s);
    }), d(this, "removeChild", (s) => {
      this.children.delete(s);
    }), d(this, "stopChildren", () => {
      this.children.forEach((s) => s.stop()), this.children.clear();
    }), d(this, "setParent", (s) => {
      this.parent = s;
    }), d(this, "spawn", (s, r) => {
      const o = wt(s);
      return r && (o.id = r), o.type = "machine.actor", o.setParent(this), this.children.set(o.id, j(o)), o.onDone(() => {
        this.removeChild(o.id);
      }).start(), j(St(o));
    }), d(this, "stopActivity", (s) => {
      var o;
      if (!this.state.value)
        return;
      const r = this.activityEvents.get(this.state.value);
      (o = r == null ? void 0 : r.get(s)) == null || o(), r == null || r.delete(s);
    }), d(this, "addActivityCleanup", (s, r, o) => {
      var a;
      s && (this.activityEvents.has(s) ? (a = this.activityEvents.get(s)) == null || a.set(r, o) : this.activityEvents.set(s, /* @__PURE__ */ new Map([[r, o]])));
    }), d(this, "setState", (s) => {
      this.state.previousValue = this.state.value, this.state.value = s;
      const r = this.getStateNode(s);
      s == null ? oe(this.state.tags) : this.state.tags = M(r == null ? void 0 : r.tags);
    }), d(this, "setContext", (s) => {
      s && Nt(this.state.context, Z(s));
    }), d(this, "setOptions", (s) => {
      const r = Z(s);
      this.actionMap = { ...this.actionMap, ...r.actions }, this.delayMap = { ...this.delayMap, ...r.delays }, this.activityMap = { ...this.activityMap, ...r.activities }, this.guardMap = { ...this.guardMap, ...r.guards };
    }), d(this, "getStateNode", (s) => {
      var r;
      if (s)
        return (r = this.config.states) == null ? void 0 : r[s];
    }), d(this, "getNextStateInfo", (s, r) => {
      const o = this.determineTransition(s, r), a = !(o != null && o.target), u = (o == null ? void 0 : o.target) ?? this.state.value, l = this.state.value !== u, p = this.getStateNode(u), w = {
        reenter: !a && !l && !(o != null && o.internal),
        transition: o,
        stateNode: p,
        target: u,
        changed: l
      };
      return this.log("NextState:", `[${r.type}]`, this.state.value, "---->", w.target), w;
    }), d(this, "getAfterActions", (s, r) => {
      let o;
      return {
        entry: () => {
          o = globalThis.setTimeout(() => {
            const a = this.getNextStateInfo(s, this.state.event);
            this.performStateChangeEffects(this.state.value, a, this.state.event);
          }, r);
        },
        exit: () => {
          globalThis.clearTimeout(o);
        }
      };
    }), d(this, "getDelayedEventActions", (s) => {
      const r = this.getStateNode(s), o = this.state.event;
      if (!r || !r.after)
        return;
      const a = [], u = [];
      if (U(r.after)) {
        const l = this.determineTransition(r.after, o);
        if (!l)
          return;
        if (!ue(l, "delay"))
          throw new Error(`[@zag-js/core > after] Delay is required for after transition: ${JSON.stringify(l)}`);
        const E = k(l.delay, this.delayMap)(this.contextSnapshot, o), w = this.getAfterActions(l, E);
        return a.push(w.entry), u.push(w.exit), { entries: a, exits: u };
      }
      if ($(r.after))
        for (const l in r.after) {
          const p = r.after[l], w = k(l, this.delayMap)(this.contextSnapshot, o), N = this.getAfterActions(p, w);
          a.push(N.entry), u.push(N.exit);
        }
      return { entries: a, exits: u };
    }), d(this, "executeActions", (s, r) => {
      var a;
      const o = et(s, this.guardMap)(this.contextSnapshot, r, this.guardMeta);
      for (const u of M(o)) {
        const l = O(u) ? (a = this.actionMap) == null ? void 0 : a[u] : u;
        tt(
          O(u) && !l,
          `[@zag-js/core > execute-actions] No implementation found for action: \`${u}\``
        ), l == null || l(this.state.context, r, this.meta);
      }
    }), d(this, "executeActivities", (s, r, o) => {
      var a;
      for (const u of r) {
        const l = O(u) ? (a = this.activityMap) == null ? void 0 : a[u] : u;
        if (!l) {
          tt(`[@zag-js/core > execute-activity] No implementation found for activity: \`${u}\``);
          continue;
        }
        const p = l(this.state.context, s, this.meta);
        if (p) {
          const E = O(u) ? u : u.name || bt();
          this.addActivityCleanup(o ?? this.state.value, E, p);
        }
      }
    }), d(this, "createEveryActivities", (s, r) => {
      if (s)
        if (U(s)) {
          const o = M(s).find((p) => {
            const E = p.delay, N = k(E, this.delayMap)(this.contextSnapshot, this.state.event);
            return Rt(p.guard, this.guardMap)(this.contextSnapshot, this.state.event, this.guardMeta) ?? N != null;
          });
          if (!o)
            return;
          const u = k(o.delay, this.delayMap)(this.contextSnapshot, this.state.event);
          r(() => {
            const p = globalThis.setInterval(() => {
              this.executeActions(o.actions, this.state.event);
            }, u);
            return () => {
              globalThis.clearInterval(p);
            };
          });
        } else
          for (const o in s) {
            const a = s == null ? void 0 : s[o], l = k(o, this.delayMap)(this.contextSnapshot, this.state.event);
            r(() => {
              const E = globalThis.setInterval(() => {
                this.executeActions(a, this.state.event);
              }, l);
              return () => {
                globalThis.clearInterval(E);
              };
            });
          }
    }), d(this, "setEvent", (s) => {
      this.state.previousEvent = this.state.event, this.state.event = St(x(s));
    }), d(this, "performExitEffects", (s, r) => {
      const o = this.state.value;
      if (o === "")
        return;
      const a = s ? this.getStateNode(s) : void 0;
      this.stopActivities(o);
      const u = et(a == null ? void 0 : a.exit, this.guardMap)(this.contextSnapshot, r, this.guardMeta), l = M(u), p = this.delayedEvents.get(o);
      p && l.push(...p), this.executeActions(l, r);
    }), d(this, "performEntryEffects", (s, r) => {
      const o = this.getStateNode(s), a = M(o == null ? void 0 : o.activities);
      this.createEveryActivities(o == null ? void 0 : o.every, (E) => {
        a.unshift(E);
      }), a.length > 0 && this.executeActivities(r, a);
      const u = et(o == null ? void 0 : o.entry, this.guardMap)(
        this.contextSnapshot,
        r,
        this.guardMeta
      ), l = M(u), p = this.getDelayedEventActions(s);
      o != null && o.after && p && (this.delayedEvents.set(s, p == null ? void 0 : p.exits), l.push(...p.entries)), this.executeActions(l, r), (o == null ? void 0 : o.type) === "final" && (this.state.done = !0, this.doneListeners.forEach((E) => {
        E(this.stateSnapshot);
      }), this.stop());
    }), d(this, "performTransitionEffects", (s, r) => {
      const o = this.determineTransition(s, r);
      this.executeActions(o == null ? void 0 : o.actions, r);
    }), d(this, "performStateChangeEffects", (s, r, o) => {
      this.setEvent(o);
      const a = r.changed || r.reenter;
      a && this.performExitEffects(s, o), this.performTransitionEffects(r.transition, o), this.setState(r.target), a && this.performEntryEffects(r.target, o);
    }), d(this, "determineTransition", (s, r) => {
      const o = Ee(s, this.guardMap);
      return o == null ? void 0 : o(this.contextSnapshot, r, this.guardMeta);
    }), d(this, "sendParent", (s) => {
      var o;
      this.parent || K("[@zag-js/core > send-parent] Cannot send event to an unknown parent");
      const r = x(s);
      (o = this.parent) == null || o.send(r);
    }), d(this, "log", (...s) => {
      he() && this.options.debug && console.log(...s);
    }), d(this, "send", (s) => {
      const r = x(s);
      this.transition(this.state.value, r);
    }), d(this, "transition", (s, r) => {
      var p, E;
      const o = O(s) ? this.getStateNode(s) : s == null ? void 0 : s.stateNode, a = x(r);
      if (!o && !this.config.on) {
        const w = this.status === "Stopped" ? "[@zag-js/core > transition] Cannot transition a stopped machine" : `[@zag-js/core > transition] State does not have a definition for \`state\`: ${s}, \`event\`: ${a.type}`;
        tt(w);
        return;
      }
      const u = ((p = o == null ? void 0 : o.on) == null ? void 0 : p[a.type]) ?? ((E = this.config.on) == null ? void 0 : E[a.type]), l = this.getNextStateInfo(u, a);
      return this.performStateChangeEffects(this.state.value, l, a), l.stateNode;
    }), d(this, "subscribe", (s) => (this.stateListeners.add(s), this.status === "Running" && s(this.stateSnapshot), () => {
      this.stateListeners.delete(s);
    })), d(this, "onDone", (s) => (this.doneListeners.add(s), this)), d(this, "onTransition", (s) => (this.stateListeners.add(s), this.status === "Running" && s(this.stateSnapshot), this)), this.config = xt(t), this.options = xt(e ?? {}), this.id = this.config.id ?? `machine-${bt()}`, this.guardMap = ((n = this.options) == null ? void 0 : n.guards) ?? {}, this.actionMap = ((c = this.options) == null ? void 0 : c.actions) ?? {}, this.delayMap = ((h = this.options) == null ? void 0 : h.delays) ?? {}, this.activityMap = ((y = this.options) == null ? void 0 : y.activities) ?? {}, this.sync = ((f = this.options) == null ? void 0 : f.sync) ?? !1, this.state = ve(this.config), this.initialContext = C(this.state.context);
    const i = x(
      "machine.created"
      /* Created */
    );
    this.executeActions((v = this.config) == null ? void 0 : v.created, i);
  }
  // immutable state value
  get stateSnapshot() {
    return j(C(this.state));
  }
  getState() {
    return this.stateSnapshot;
  }
  // immutable context value
  get contextSnapshot() {
    return this.stateSnapshot.context;
  }
  /**
   * A reference to the instance methods of the machine.
   * Useful when spawning child machines and managing the communication between them.
   */
  get self() {
    const t = this;
    return {
      id: this.id,
      send: this.send.bind(this),
      sendParent: this.sendParent.bind(this),
      sendChild: this.sendChild.bind(this),
      stop: this.stop.bind(this),
      stopChild: this.stopChild.bind(this),
      spawn: this.spawn.bind(this),
      stopActivity: this.stopActivity.bind(this),
      get state() {
        return t.stateSnapshot;
      },
      get initialContext() {
        return t.initialContext;
      },
      get initialState() {
        var e;
        return ((e = t.initialState) == null ? void 0 : e.target) ?? "";
      }
    };
  }
  get meta() {
    var t;
    return {
      state: this.stateSnapshot,
      guards: this.guardMap,
      send: this.send.bind(this),
      self: this.self,
      initialContext: this.initialContext,
      initialState: ((t = this.initialState) == null ? void 0 : t.target) ?? "",
      getState: () => this.stateSnapshot,
      getAction: (e) => this.actionMap[e],
      getGuard: (e) => this.guardMap[e]
    };
  }
  get guardMeta() {
    return {
      state: this.stateSnapshot
    };
  }
  get [Symbol.toStringTag]() {
    return "Machine";
  }
}, Ue = (t, e) => new we(t, e), be = (...t) => t.map((e) => {
  var i;
  return (i = e == null ? void 0 : e.trim) == null ? void 0 : i.call(e);
}).filter(Boolean).join(" "), xe = /^on[A-Z]/;
function Lt(...t) {
  let e = {};
  for (let i of t) {
    for (let n in e) {
      if (xe.test(n) && typeof e[n] == "function" && typeof i[n] == "function") {
        e[n] = ae(e[n], i[n]);
        continue;
      }
      if (n === "className" || n === "class") {
        e[n] = be(e[n], i[n]);
        continue;
      }
      if (n === "style") {
        e[n] = Object.assign({}, e[n] ?? {}, i[n] ?? {});
        continue;
      }
      e[n] = i[n] !== void 0 ? i[n] : e[n];
    }
    for (let n in i)
      e[n] === void 0 && (e[n] = i[n]);
  }
  return e;
}
function Ae(t) {
  return new Proxy({}, {
    get() {
      return t;
    }
  });
}
var Je = () => (t) => Array.from(new Set(t)), Ze = Ae((t) => t), Oe = typeof document < "u" ? qt : F, At = (t) => (t == null ? void 0 : t.constructor.name) === "Array", Tt = (t, e) => {
  if (Object.is(t, e))
    return !0;
  if (t == null && e != null || t != null && e == null)
    return !1;
  if (typeof (t == null ? void 0 : t.isEqual) == "function" && typeof (e == null ? void 0 : e.isEqual) == "function")
    return t.isEqual(e);
  if (typeof t == "function" && typeof e == "function")
    return t.toString() === e.toString();
  if (At(t) && At(e))
    return Array.from(t).toString() === Array.from(e).toString();
  if (typeof t != "object" || typeof e != "object")
    return !1;
  const i = Object.keys(e ?? /* @__PURE__ */ Object.create(null)), n = i.length;
  for (let c = 0; c < n; c++)
    if (!Reflect.has(t, i[c]))
      return !1;
  for (let c = 0; c < n; c++) {
    const h = i[c];
    if (!Tt(t[h], e[h]))
      return !1;
  }
  return !0;
};
function Wt(t) {
  if (!je(t) || t === void 0)
    return t;
  const e = Reflect.ownKeys(t).filter((n) => typeof n == "string"), i = {};
  for (const n of e) {
    const c = t[n];
    c !== void 0 && (i[n] = Wt(c));
  }
  return i;
}
var je = (t) => t && typeof t == "object" && t.constructor === Object;
function Pe(t) {
  const e = L();
  return F(() => {
    e.current = t;
  }), e.current;
}
function Me(t, e) {
  const i = L(!1), n = L(!1);
  F(() => {
    if (i.current && n.current)
      return t();
    n.current = !0;
  }, e), F(() => (i.current = !0, () => {
    i.current = !1;
  }), []);
}
var { use: Ot } = zt, Ce = /* @__PURE__ */ new WeakMap();
function De(t, e) {
  const { actions: i, context: n, sync: c } = e ?? {}, h = L(), y = L(), f = It(
    Vt((a) => rt(t.state, a, c), [c]),
    () => {
      const a = C(t.state, Ot);
      try {
        if (h.current && y.current && !Dt(h.current, a, y.current, /* @__PURE__ */ new WeakMap()))
          return h.current;
      } catch {
      }
      return a;
    },
    () => C(t.state, Ot)
  );
  t.setOptions({ actions: i });
  const v = Pe(n), s = pt(() => Wt(n ?? {}), [n]);
  Me(() => {
    Object.entries(s).map(([p, E]) => ({
      key: p,
      curr: E,
      prev: v == null ? void 0 : v[p],
      equal: Tt(v == null ? void 0 : v[p], E)
    })).every(({ equal: p }) => p) || t.setContext(s);
  }, [s]);
  const r = /* @__PURE__ */ new WeakMap();
  F(() => {
    h.current = f, y.current = r;
  });
  const o = pt(() => /* @__PURE__ */ new WeakMap(), []);
  return Ct(f, r, o, Ce);
}
function Ne(t) {
  const e = L();
  return e.current || (e.current = { v: t() }), e.current.v;
}
function _e(t, e) {
  const { state: i, context: n } = e ?? {}, c = Ne(() => {
    const h = typeof t == "function" ? t() : t;
    return n && h.setContext(n), h;
  });
  return Oe(() => (c.start(i), () => {
    c.stop();
  }), []), c;
}
function Qe(t, e) {
  const i = _e(t, e);
  return [De(i, e), i.send, i];
}
function Re(t, e) {
  typeof t == "function" ? t(e) : t != null && (t.current = e);
}
function Le(...t) {
  return (e) => t.forEach((i) => Re(i, e));
}
const st = (t) => {
  const e = Kt(
    ct((i, n) => {
      const { asChild: c, children: h, ...y } = i;
      if (!c)
        return Gt(t, { ...y, ref: n }, h);
      const f = Bt.only(h);
      return Ut(f) ? Jt(f, {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        ...Lt(y, f.props),
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        ref: n ? Le(n, f.ref) : f.ref
      }) : null;
    })
  );
  return e.displayName = t.displayName || t.name, e;
}, Te = () => {
  const t = /* @__PURE__ */ new Map();
  return new Proxy(st, {
    apply(e, i, n) {
      return st(n[0]);
    },
    get(e, i) {
      const n = i;
      return t.has(n) || t.set(n, st(n)), t.get(n);
    }
  });
}, We = Te(), [Xe, ke] = Qt({
  name: "SwitchContext",
  hookName: "useSwitchContext",
  providerName: "<SwitchProvider />"
}), ot = ct((t, e) => {
  const i = ke(), n = Lt(i.labelProps, t);
  return /* @__PURE__ */ A(We.span, { ...n, ref: e });
});
ot.displayName = "SwitchLabel";
const jt = ({
  description: t,
  label: e,
  showInfoIcon: i = !1,
  style: n,
  tooltip: c
}) => t ? /* @__PURE__ */ Y(G.div, { __css: n.labelTextContainer, children: [
  /* @__PURE__ */ Y(dt, { size: "lg", fontWeight: "medium", sx: n.tooltipIcon, children: [
    e,
    " ",
    i && /* @__PURE__ */ A(yt, { label: c, shouldWrapChildren: !0, placement: "top", children: /* @__PURE__ */ A(gt, {}) })
  ] }),
  /* @__PURE__ */ A(dt, { size: "lg", fontWeight: "normal", children: t })
] }) : /* @__PURE__ */ Y(G.div, { __css: n.tooltipIcon, children: [
  e,
  " ",
  i && /* @__PURE__ */ A(yt, { label: c, shouldWrapChildren: !0, placement: "top", children: /* @__PURE__ */ A(gt, {}) })
] }), Ye = ct(
  ({ description: t, label: e, tooltip: i, style: n }, c) => i && e ? /* @__PURE__ */ A(G.div, { as: ot, __css: { ...n.label, ...n.labelTooltip }, children: /* @__PURE__ */ A(
    jt,
    {
      style: n,
      label: e,
      description: t,
      showInfoIcon: !0,
      tooltip: i
    }
  ) }) : e ? /* @__PURE__ */ A(G.div, { as: ot, __css: n.label, ref: c, children: /* @__PURE__ */ A(jt, { label: e, description: t, style: n }) }) : null
);
export {
  Xe as S,
  Ye as T,
  Ue as a,
  Je as b,
  Qt as c,
  We as d,
  Qe as e,
  Be as g,
  Lt as m,
  Ze as n,
  ke as u
};
//# sourceMappingURL=index-c6798772.js.map
